import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as style from './AbaToastContainer.styl';
const CustomCloseButton = ({ closeToast }) => (_jsx("span", { onClick: closeToast, className: "icon icon-times toastify__close" }));
export class AbaToastContainer extends React.Component {
    render() {
        return (_jsx(ToastContainer, { closeButton: _jsx(CustomCloseButton, {}), className: style.global, position: "top-center", hideProgressBar: true, autoClose: 2000, closeOnClick: true, icon: false }));
    }
}
